/* eslint-disable sort-keys-fix/sort-keys-fix */
import React from 'react';

// Components
import { Box } from '@mui/material';
import DesktopBlur from 'assets/img/rwt_blurred_desktop.png';
import MobileBlur from 'assets/img/rwt_blurred_mobile.png';
import SubscriptionDialog from './SubscriptionDialog';

const NonSubscriberPage = () => (
  <Box
    sx={{
      backgroundImage: { xs: `url(${MobileBlur})`, md: `url(${DesktopBlur})` },
      backgroundSize: 'cover',
      height: '100%',
      maxWidth: { xs: 'revert', md: 1280 },
      overflow: 'hidden',
      position: 'absolute',
      top: { xs: 'revert', sm: -66, lg: 'revert' },
      width: '100%',
    }}
  >
    <SubscriptionDialog />
  </Box>
);

export default NonSubscriberPage;
